export class FileResults {
  static listOfInfectedFilesMap: Map<String, String[]> = new Map<String, String[]>();
}
